import * as actionTypes from "../ActionTypes/index";

// ✅ Save Team Video
export const saveTeamVideoRequest = (payload, callback) => ({
    type: actionTypes.SAVE_TEAM_VIDEO_REQUEST,
    payload, // directly pass the object
    callback,
  });
  

export const saveTeamVideoSuccess = (data) => ({
  type: actionTypes.SAVE_TEAM_VIDEO_SUCCESS,
  payload: data,
});

export const saveTeamVideoFailure = (error) => ({
  type: actionTypes.SAVE_TEAM_VIDEO_FAILURE,
  payload: error,
});

// ✅ Update Team Video
export const updateTeamVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_TEAM_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateTeamVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_TEAM_VIDEO_SUCCESS,
  payload: data,
});

export const updateTeamVideoFailure = (error) => ({
  type: actionTypes.UPDATE_TEAM_VIDEO_FAILURE,
  payload: error,
});

// ✅ Delete Team Video
export const deleteTeamVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_TEAM_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteTeamVideoSuccess = (data) => ({
  type: actionTypes.DELETE_TEAM_VIDEO_SUCCESS,
  payload: data,
});

export const deleteTeamVideoFailure = (error) => ({
  type: actionTypes.DELETE_TEAM_VIDEO_FAILURE,
  payload: error,
});

// ✅ Read Team Videos
export const readTeamVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_TEAM_VIDEO_REQUEST,
  payload,
  callback,
});

export const readTeamVideoSuccess = (data) => ({
  type: actionTypes.READ_TEAM_VIDEO_SUCCESS,
  payload: data,
});

export const readTeamVideoFailure = (error) => ({
  type: actionTypes.READ_TEAM_VIDEO_FAILURE,
  payload: error,
});
